export default __webpack_public_path__ + "static/media/aboutslider2.78fd1f06.webp";